<template>
    <app-layout>
        <template #header>
            <FarmTitle :farm="farm">
                Auszug von {{ horse.name }}
            </FarmTitle>
        </template>

        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg">
                    <div class="p-8">
                        <div>
                            <h3 class="text-lg leading-6 font-medium text-gray-900">
                                Informationen zum Auszug
                            </h3>
                        </div>
                        <div class="mt-6 md:grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
                            <div class="col-span-6">
                                <label for="date" class="block text-sm font-medium text-gray-700">
                                    Datum
                                </label>
                                <div class="mt-1">
                                    <input type="date" name="first_name" id="date" v-model="form.date" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                    <jet-input-error :message="form.errors.date" />
                                </div>
                            </div>
                            <div class="col-span-6" v-if="new Date(farm.last_export).getTime() > new Date(form.date)">
                                <div class="flex items-center justify-between">
                                      <span class="flex-grow flex flex-col">
                                        <span class="text-sm font-medium text-gray-900">Differenzbetrag seit Abrechnung berechnen</span>
                                        <span class="text-sm text-gray-500">Differenzbetrag seit der letzten Abrechnung ({{ new Intl.DateTimeFormat().format(new Date(farm.last_export)) }}) erstatten</span>
                                      </span>
                                    <button type="button" @click="form.refund_difference = !form.refund_difference" :class="form.refund_difference ? 'bg-indigo-600' : 'bg-gray-200'" class="bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" role="switch" aria-checked="false" aria-labelledby="availability-label">
                                        <span class="sr-only">Use setting</span>
                                        <span aria-hidden="true" :class="form.refund_difference ? 'translate-x-5' : 'translate-x-0'" class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                    </button>
                                </div>
                            </div>
                            <template v-if="new Date(earliest_date).getTime() > new Date(form.date)">
                                <div class="col-span-6">
                                    <div class="flex items-center justify-between">
                                  <span class="flex-grow flex flex-col" id="availability-label">
                                    <span class="text-sm font-medium text-gray-900">Leerbox berechnen</span>
                                    <span class="text-sm text-gray-500">Das Pferd zieht vor dem Erreichen der Kündigungsfrist aus. Soll eine Leerbox berechnet werden? <span class="text-red-400">Die Leerbox wird als Einzelposten berechnet</span></span>
                                  </span>
                                        <button type="button" @click="form.earlier = !form.earlier" :class="form.earlier ? 'bg-indigo-600' : 'bg-gray-200'" class="bg-gray-200 relative inline-flex flex-shrink-0 h-6 w-11 border-2 border-transparent rounded-full cursor-pointer transition-colors ease-in-out duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500" role="switch" aria-checked="false" aria-labelledby="availability-label">
                                            <span class="sr-only">Use setting</span>
                                            <span aria-hidden="true" :class="form.earlier ? 'translate-x-5' : 'translate-x-0'" class="translate-x-0 pointer-events-none inline-block h-5 w-5 rounded-full bg-white shadow transform ring-0 transition ease-in-out duration-200"></span>
                                        </button>
                                    </div>
                                </div>
                                <div class="col-span-6" v-if="form.earlier">
                                    <label for="date_empty" class="block text-sm font-medium text-gray-700">
                                        Leerbox berechnen bis
                                    </label>
                                    <div class="mt-1">
                                        <input type="date" name="first_name" id="date_empty" :min="new Date(new Date(form.date).setDate(new Date(form.date).getDate() + 1)).toISOString().split('T')[0]" v-model="form.empty_till" autocomplete="given-name" class="shadow-sm focus:ring-indigo-500 focus:border-indigo-500 block w-full sm:text-sm border-gray-300 rounded-md" />
                                        <jet-input-error :message="form.errors.empty_till" />
                                    </div>
                                </div>
                            </template>
                        </div>
                        <div class="px-4 py-5 bg-white shadow rounded-lg overflow-hidden sm:p-6 mt-3">
                            <dt class="text-sm font-medium text-gray-500 truncate">
                                Zusammensetzung der Endabrechnung
                            </dt>
                            <dd class="mt-1">
                                <div class="grid grid-cols-12 h-16 mt-4 text-center gap-1">
                                    <div class="bg-indigo-500 h-full rounded text-white flex justify-center items-center" :class="form.date == earliest_date ? 'col-span-12' : form.earlier ? new Date(form.empty_till) < new Date(earliest_date) ? 'col-span-5' : 'col-span-6' : 'col-span-8 md:col-span-9'">{{ new Intl.DateTimeFormat().format(new Date(farm.last_export).setDate(new Date(farm.last_export).getDate() + 1)) }}-{{ new Intl.DateTimeFormat().format(new Date(form.date)) }} (Vollpreis, wird wie normale Stallmiete abgebucht)</div>
                                    <div class="bg-yellow-500 h-full rounded text-white flex justify-center items-center" :class="!form.earlier ? 'hidden' : new Date(form.empty_till) < new Date(earliest_date) ? 'col-span-2 md:col-span-4' : 'col-span-6 md:col-span-6'">{{ new Intl.DateTimeFormat().format(new Date(form.date).setDate(new Date(form.date).getDate() + 1)) }}-{{ new Intl.DateTimeFormat().format(new Date(form.empty_till)) }} (Leerpreis, wird bei nächstem Export abgebucht)</div>
                                    <div v-if="new Date(form.date) < new Date(earliest_date) && (!form.earlier || (form.earlier && new Date(form.empty_till) < new Date(earliest_date)))" class="bg-gray-500 text-white h-full rounded flex justify-center items-center col-span-5 md:col-span-3">Zeit bis zur Kündigungsfrist ({{ new Intl.DateTimeFormat().format(new Date(earliest_date)) }})</div>
                                </div>
                            </dd>
                        </div>
                    </div>
                    <div class="pt-5 pr-8 pb-8">
                        <div class="flex justify-end">
                            <inertia-link :disabled="form.processing" :href="route('farm.horses', horse.farm)" type="button" class="bg-white py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Abbrechen
                            </inertia-link>
                            <button :disabled="form.processing" @click="form.post(route('horse.offboard.post', horse))" class="ml-3 inline-flex justify-center py-2 px-4 border border-transparent shadow-sm text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                                Auszug bestätigen
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </app-layout>
</template>

<script>
    import AppLayout from "@/Layouts/AppLayout";
    import JetInputError from "@/Jetstream/InputError";
    import FarmTitle from "@/Layouts/FarmTitle";

    export default {
        name: "OffBoarding",
        components: {FarmTitle, AppLayout, JetInputError },
        props: ['farm', 'horse', 'earliest_date'],
        data() {
            return {
                form: this.$inertia.form({
                    date: this.earliest_date,
                    earlier: false,
                    empty_till: this.earliest_date,
                    refund_difference: false,
                })
            }
        }
    }
</script>

<style scoped>

</style>
